import React from 'react'

import {withStyles} from 'material-ui'

import Hero, {HeroContent} from './Hero'
import MainNav from './MainNav'
import TitledPage from './TitledPage'

const styles = theme => ({
    heroContent: {
        textAlign: 'center',
    },
    hero: {
        backgroundColor: theme.palette.hero,
        minHeight: 120,
        padding: "0 20px",
        paddingBottom: 120,
    },
    card: {
        position: 'relative',
        top: -120,
        zIndex: 1,
        border: '1px solid black',
        width: 600,
        margin: "0 auto",
        padding: 20,
    },
})

export const Contact = withStyles(styles)(
    ({classes, ...props}) => (
        <TitledPage title="Carefol.io | sign up">
            <Hero classes={{root: classes.hero}}>
                <MainNav/>
                <HeroContent className={classes.heroContent}>
                    <h1>Check your email</h1>
                    <p>
                        Thank you for signing up for Carefolio!
                    </p>
                    <p>
                        Your next step is to check your email for a message from us to
                        activate your account.
                    </p>
                    <p>
                        In the meantime, feel free to click around to learn all the things you can do with Carefolio!
                    </p>
                </HeroContent>
            </Hero>
        </TitledPage>
    )
)

export default Contact


// WEBPACK FOOTER //
// ./src/components/SignupThanks.jsx